import type { ReactElement, ReactNode } from 'react'
import { FileSearch01Icon } from '@/components/ui/icons'
import { Spinner } from '@/components/ui/spinner'

export const PhotosetIndex = ({
	title,
	endSlot,
	isLoading
}: {
	title: string | ReactElement
	endSlot?: ReactNode
	isLoading?: boolean
}) => {
	return (
		<div className='flex h-full w-full flex-col items-center justify-center bg-neutral-50'>
			{isLoading ? (
				<Spinner className='fill-neutral-500' size={48} />
			) : (
				<>
					<FileSearch01Icon
						className='fill-neutral-600'
						height={48}
						width={48}
					/>
					<div className='mx-auto mt-8 mb-6 flex w-[392px] flex-col items-center gap-6 text-center'>
						<h1 className='font-bold text-2xl text-neutral-900'>
							{title}
						</h1>
						{endSlot}
					</div>
				</>
			)}
		</div>
	)
}
